import { useChat } from '../contexts/ChatContext'

export default function ProgressChips() {
  const { progressStages } = useChat()

  if (progressStages.length === 0) return null

  return (
    <div className="px-4 md:px-8 lg:px-12 py-3 bg-muted/5">
      <div className="max-w-5xl mx-auto">
        {/* Process Pipeline */}
        <div className="relative flex items-center justify-center gap-1">
          {progressStages.map((stage, index) => {
            const isLast = index === progressStages.length - 1
            const isCompleted = !isLast

            return (
              <div key={index} className="flex items-center">
                {/* Stage Node */}
                <div
                  className={`
                    relative flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium
                    border transition-all duration-300
                    ${isCompleted
                      ? 'bg-green-50/50 dark:bg-green-900/10 text-green-700 dark:text-green-400 border-green-300/50 dark:border-green-700/50'
                      : 'bg-primary/10 text-primary border-primary/30 ring-2 ring-primary/20'
                    }
                  `}
                >
                  {/* Icon */}
                  <span className={`text-xs ${!isCompleted && 'animate-spin'}`}>
                    {isCompleted ? '✓' : '○'}
                  </span>

                  {/* Text */}
                  <span className="whitespace-nowrap">{stage.text}</span>
                </div>

                {/* Connector Arrow */}
                {!isLast && (
                  <div className="flex items-center mx-1">
                    <svg className="w-3 h-3 text-muted-foreground/40" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
